/**
 * @generated SignedSource<<3901e126e9ae6ead3eef3ba8c4cfd7ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreExtraAdminFieldType = "STRING" | "STRING_LIST";
export type OrgStoreAdminQuery$variables = {
  storeId: string;
};
export type OrgStoreAdminQuery$data = {
  readonly store: {
    readonly address: string | null;
    readonly externalId: string | null;
    readonly extraAdminFields: ReadonlyArray<{
      readonly description: string | null;
      readonly key: string;
      readonly label: string;
      readonly type: StoreExtraAdminFieldType;
      readonly value: string | null;
    }>;
    readonly id: string;
    readonly locale: string;
    readonly name: string;
    readonly timezone: string;
    readonly workspaceOwner: {
      readonly id: string;
      readonly name: string;
    } | null;
  };
  readonly viewer: {
    readonly workspaces: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelector_workspaces">;
    }> | null;
  } | null;
};
export type OrgStoreAdminQuery = {
  response: OrgStoreAdminQuery$data;
  variables: OrgStoreAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "storeId"
    }
  ],
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspaceOwner",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreExtraAdminField",
      "kind": "LinkedField",
      "name": "extraAdminFields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoreAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSelector_workspaces"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgStoreAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "af331f2f0b8aaf0f1fedf7f2a04e7dd8",
    "id": null,
    "metadata": {},
    "name": "OrgStoreAdminQuery",
    "operationKind": "query",
    "text": "query OrgStoreAdminQuery(\n  $storeId: ID!\n) {\n  viewer {\n    workspaces {\n      ...WorkspaceSelector_workspaces\n      id\n    }\n  }\n  store(id: $storeId) {\n    id\n    name\n    workspaceOwner {\n      id\n      name\n    }\n    locale\n    timezone\n    externalId\n    extraAdminFields {\n      key\n      label\n      description\n      type\n      value\n    }\n    address\n  }\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n\nfragment WorkspaceSelector_workspaces on Workspace {\n  id\n  name\n  parentId\n  ...WorkspaceSelectorContent_workspaces\n}\n"
  }
};
})();

(node as any).hash = "7bc3993893ca18b2b3cb216aa704132a";

export default node;
